export const LOCAL_API_URL = 'http://localhost:8000/bbl/';
export const REMOTE_API_URL = 'https://warm-scrubland-91339.herokuapp.com/bbl/';

export const IMAGES_BUCKET = `https://scpbimages.s3.ap-southeast-2.amazonaws.com/bblimages/`